import type { GetDashboardTabPathParams } from '../types';

const getDashboardTabPath = ({ tabId, search }: GetDashboardTabPathParams): string => {
    const pathname = `/admin/dashboard/${tabId}`;
    return `${pathname}${search}`;
};

export default getDashboardTabPath;
